import { IFooter, IUserIRoute } from "../generated/Api";

function format(
  body: string,
  user: IUserIRoute,
  emailInfo: {
    footer?: IFooter;
    footerId?: string;
    defaultModeColorLink?: string;
  }
) {
  // Start footer logic
  let { address, company, companyPhone } = user;
  let footer = ``;

  let footerForUseInEmail;

  if (emailInfo.footer) footerForUseInEmail = emailInfo.footer;
  else {
    const footerFromUser = user.emailOptions.footers.find(
      (footer) => footer.id === emailInfo.footerId
    );
    footerForUseInEmail = footerFromUser || user.emailOptions.footers[0];
  }

  let {
    signature,
    additionalFooterText,
    textBeforeUnsubscribe,
    textAfterUnsubscribe,
    hasSeparatorLine,
  } = footerForUseInEmail;

  let FOOTER_signature = signature?.trimEnd();

  // Trim it all
  let [
    FOOTER_additionalFooterText,
    FOOTER_textBeforeUnsubscribe,
    FOOTER_textAfterUnsubscribe,

    FOOTER_address,
    FOOTER_company,
    FOOTER_companyPhone,
  ] = [
    additionalFooterText,
    textBeforeUnsubscribe,
    textAfterUnsubscribe,

    address,
    company,
    companyPhone,
  ].map((t) => t?.trim()) as string[];

  if (FOOTER_signature && FOOTER_signature !== "") {
    footer += `${FOOTER_signature}\n`;
  }

  footer += `\n\n\n\n`;
  if (hasSeparatorLine === "BEFORE_FOOTER")
    footer += `<div style="max-width: 600px"><hr width="80%"></div>\n`;

  if (FOOTER_additionalFooterText && FOOTER_additionalFooterText !== "") {
    footer += `${FOOTER_additionalFooterText}\n\n`;
  }

  if (FOOTER_textBeforeUnsubscribe && FOOTER_textBeforeUnsubscribe !== "") {
    if (FOOTER_textBeforeUnsubscribe.endsWith(".")) {
      footer +=
        `${FOOTER_textBeforeUnsubscribe} ` +
        `<a style="color: black !important; font-size: inherit;" href="https://app.berserkermail.com/unsubscribe?id=%recipient.contactId%" target="_blank">Unsubscribe</a>`;
    } else {
      footer +=
        `${FOOTER_textBeforeUnsubscribe} ` +
        `<a style="color: black !important; font-size: inherit;" href="https://app.berserkermail.com/unsubscribe?id=%recipient.contactId%" target="_blank">unsubscribe</a>`;
    }
  } else {
    footer += `<a style="color: black !important; font-size: inherit;" href="https://app.berserkermail.com/unsubscribe?id=%recipient.contactId%" target="_blank">Unsubscribe</a>`;
  }

  if (FOOTER_textAfterUnsubscribe && FOOTER_textAfterUnsubscribe !== "") {
    footer += ` ${FOOTER_textAfterUnsubscribe}`;
  }

  // CAN-SPAM logic
  const addressMultiLine =
    FOOTER_address.trim()
      .split("")
      .reduce((acc, char) => (char === "\n" ? acc + 1 : acc), 0) > 0;

  let FOOTER_CAN_SPAM = `\n${FOOTER_company}, ${FOOTER_address}${
    FOOTER_companyPhone ? ` - ${FOOTER_companyPhone}` : ""
  }`;

  if (addressMultiLine) {
    FOOTER_CAN_SPAM = `\n${FOOTER_company}\n${FOOTER_address}${
      FOOTER_companyPhone ? `\n${FOOTER_companyPhone}` : ""
    }`;
  }

  if (hasSeparatorLine === "BEFORE_CAN") {
    footer += "\n\n\n\n\n";
    footer += `<div style="max-width: 600px"><hr width="80%"></div>\n`;
    footer += FOOTER_CAN_SPAM;
  } else {
    footer += `\n\n\n${FOOTER_CAN_SPAM}`;
  }

  // Finish footer logic

  // url match that starts with http or https
  const matches = body.matchAll(
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(((&amp;)|(\{\{Contact\.\w+\}\})|[-a-zA-Z0-9()@:%_\+.~#?&//=])*)/g
  );

  const matchArray: { url: string; index: number }[] = [];

  let next: IteratorResult<RegExpMatchArray, any>;

  while (!(next = matches.next()).done) {
    const currentMatch = next.value;

    const url = currentMatch[0];
    if (url.includes("bmcal") || url.includes("staging.berserkermail.com")) {
      continue;
    }

    // Anchors (<a>) treating
    const urlPosition = currentMatch?.index || 0;

    if (
      body.substr(urlPosition - 6, 5) === "href=" ||
      body.substr(urlPosition - 9, 8) === "data-id=" ||
      body.substr(urlPosition - 12, 11) === "data-label=" ||
      body.substr(urlPosition + url.length, 4) === "</a>"
    ) {
      continue;
    }

    const { index } = currentMatch;

    if (index)
      matchArray.unshift({
        url,
        index,
      });
  }

  let linkedBody = body;

  //If user selected different color to link
  const defaultModeColorLink = emailInfo?.defaultModeColorLink || "#000";

  matchArray.forEach((match) => {
    const { url, index } = match;

    const linkHtml = `<a href="${url}" class="berserker-link" style="color: ${defaultModeColorLink} !important; font-size: inherit;">${url}</a>`;

    linkedBody =
      linkedBody.substring(0, index) +
      linkHtml +
      linkedBody.substring(index + url.length);
  });

  // Replace H1, H2 and H3 logic
  linkedBody = linkedBody.split(`<h1>`).join(`<h1 style="font-size: 32px;">`);
  linkedBody = linkedBody.split(`<h2>`).join(`< h2 style="font-size: 26px;">`);
  linkedBody = linkedBody.split(`<h3>`).join(`<h3 style="font-size: 22px;">`);

  return { linkedBody, footer, can_spam: FOOTER_CAN_SPAM };
}

function formatJustLink(body: string, color: string) {
  // url match that starts with http or https
  const matches = body.matchAll(
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(((&amp;)|(\{\{Contact\.\w+\}\})|[-a-zA-Z0-9()@:%_\+.~#?&//=])*)/g
  );

  const matchArray: { url: string; index: number }[] = [];

  let next: IteratorResult<RegExpMatchArray, any>;

  while (!(next = matches.next()).done) {
    const currentMatch = next.value;

    const url = currentMatch[0];
    if (url.includes("bmcal") || url.includes("staging.berserkermail.com")) {
      continue;
    }

    // Anchors (<a>) treating
    const urlPosition = currentMatch?.index || 0;

    if (
      body.substr(urlPosition - 6, 5) === "href=" ||
      body.substr(urlPosition - 9, 8) === "data-id=" ||
      body.substr(urlPosition - 12, 11) === "data-label=" ||
      body.substr(urlPosition + url.length, 4) === "</a>"
    ) {
      continue;
    }

    const { index } = currentMatch;

    if (index)
      matchArray.unshift({
        url,
        index,
      });
  }

  let linkedBody = body;

  matchArray.forEach((match) => {
    const { url, index } = match;

    const linkHtml = `<a href="${url}" colorLink="${color}" class="berserker-link" style="font-size: inherit;">${url}</a>`;

    linkedBody =
      linkedBody.substring(0, index) +
      linkHtml +
      linkedBody.substring(index + url.length);
  });

  return linkedBody;
}

export const FormatEmail = {
  format,
  formatJustLink,
};
